import React from 'react'
import ImgBg from '../img/bg-header-desktop.svg' 
import { StyledHeader, ImgHeader }  from '../styled/StyledContent'


const Hearder = () => {
  return (
    <StyledHeader>
    <ImgHeader src={ImgBg} alt=""/>
    </StyledHeader>
  )
}

export default Hearder
